import { StringUtility } from '@common/utils';
import { DateTime } from 'luxon';

export interface IPetWeightHistoryModel {
  birthDate?: string;
  visitDate: string;
  visitId: number;
  weight?: number;
  appointmentTypeName: string;
  appointmentColor: string;
}

export class PetWeightHistoryModel implements IPetWeightHistoryModel {
  birthDate?: string;
  visitDate: string;
  visitId: number;
  weight?: number;
  appointmentTypeName: string;
  appointmentColor: string;
  constructor(params: Partial<IPetWeightHistoryModel> = {}) {
    const {
      birthDate = undefined,
      visitDate = '',
      visitId = 0,
      weight = 0,
      appointmentTypeName = '',
      appointmentColor = '',
    } = params;

    const sanitizedBirthDate = StringUtility.SanitizeString(birthDate);
    const sanitizedVisitDate = StringUtility.SanitizeString(visitDate);
    this.birthDate = sanitizedBirthDate
      ? DateTime.fromISO(sanitizedBirthDate).toISODate()
      : undefined;
    this.visitDate = sanitizedVisitDate
      ? DateTime.fromISO(sanitizedVisitDate).toISODate()
      : '';
    this.visitId = visitId;
    this.weight = weight;
    this.appointmentTypeName = appointmentTypeName;
    this.appointmentColor = appointmentColor;
  }
}
